import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      const str_sub1 = value.substr(0, value.lastIndexOf('?'));
      const str_sub2 = str_sub1.substr(str_sub1.lastIndexOf('_') + 1 );
      const str_sub3 = str_sub2.replace(/%20/g, ' ');
      if (str_sub3) {
        return str_sub3;
      }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/file-name.pipe.ts